import { useEffect, useState } from "react";
import { QuestionaryType } from "../../models/QuestionaryType";
import { Button, Form, Modal, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faSave } from "@fortawesome/free-solid-svg-icons";

type Props = {
  onHide: () => void;
  onSave?: (newQuestionaryType: QuestionaryType) => void;
  show: boolean;
  questionaryType?: QuestionaryType | null;
  title?: string;
};

export const ModalQuestionaryTypeForm = (props: Props) => {
  const [questionaryType, setQuestionaryType] = useState<QuestionaryType>({
    id: 0,
    name: "",
    isActive: true,
  });
  const [validated, setValidated] = useState(false);

  const loadQuestionaryType = async () => {
    setQuestionaryType({
      name: props.questionaryType?.name || "",
      isActive: props.questionaryType?.isActive || true,
    });
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setQuestionaryType({
      ...questionaryType,
      [name]: value,
    });
  };

  const handleOnSubmit = (event: any) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    }

    questionaryType.id = props.questionaryType?.id;
    props.onSave!(questionaryType);
    setValidated(true);
  };

  const resetForm = () => {
    setQuestionaryType({
      name: "",
      isActive: false,
    });
    setValidated(false);
  };

  useEffect(() => {
    loadQuestionaryType();
  }, [props.questionaryType, props.show]);

  return (
    <Form validated={validated} noValidate>
      <Modal
        show={props.show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        onHide={props.onHide}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Stack gap={3}>
            <Form.Group>
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                maxLength={50}
                required={true}
                name="name"
                value={questionaryType.name}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Stack>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              !props.questionaryType?.id! && resetForm();
              props.onHide();
            }}
          >
            <FontAwesomeIcon icon={faBan} style={{ paddingRight: "3px" }} />
            <span className="ms-2">Cancelar</span>
          </Button>
          <Button type="submit" variant="primary" onClick={handleOnSubmit}>
            <FontAwesomeIcon
              icon={faSave}
              style={{
                paddingRight: "3px",
              }}
            />
            <span className="ms-2">Guardar</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </Form>
  );
};
